import React from "react"
import PropTypes from "prop-types"
import { Style } from "radium"
import { withRadium, DetectCompact } from "higher-order-components"
import COLOR_PALETTE from "constants/color-palette"
import { BASE_HEADING } from "constants/general-style"
import { Sticky } from "containers"
import { keyframes } from "higher-order-components/configured-radium/"
import AnimatedArrowIcon from "./animated-arrow-icon"
import AnimatedDropdown from "./animated-dropdown"
import {
  sidebarWidth,
  breakpointTablet,
  breakpointDesktop,
  desktopWidth,
  tabletWidth
} from "../settings"

const NavigationLayout = ({
  compact: [isMobile, isTablet],
  topNav,
  sideNav,
  children,
  sideNavOpen,
  topNavPanels,
  darkenBg,
  onNavButtonClick,
  onBackgroundClick
}) => (
  <div style={{ position: "relative", background: COLOR_PALETTE.GRAY1 }}>
    <Style
      scopeSelector=".no-scroll-bar"
      rules={{
        "div:-webkit-scrollbar": {
          display: "none"
        },
        "div::-webkit-scrollbar": {
          display: "none"
        }
      }} />
    <Sticky>
      <div className="no-scroll-bar" style={style.wrapper}>
        {!isTablet && <div style={[style.sidebar, { pointerEvents: "all" }]}>{sideNav}</div>}
        <div style={style.topNav}>
          <div
            onClick={onNavButtonClick}
            style={[
              style.navButton,
              sideNavOpen && { color: COLOR_PALETTE.WHITE, background: COLOR_PALETTE.GRAY1 }
            ]}>
            MyMazda&nbsp;<AnimatedArrowIcon flip={sideNavOpen} />
          </div>
          {topNav}
          <div style={style.topPanel}>
            {topNavPanels}
            {isTablet && (
              <span style={style.hideIfDesktop}>
                {darkenBg && isMobile && <div onClick={onBackgroundClick} style={style.fadedBg} />}
                <AnimatedDropdown open={sideNavOpen}>
                  <div style={style.sidebar}>{sideNav}</div>
                </AnimatedDropdown>
              </span>
            )}
          </div>
        </div>
      </div>
    </Sticky>
    <div style={style.main}>{children}</div>
  </div>
)

NavigationLayout.propTypes = {
  compact: PropTypes.arrayOf(PropTypes.bool),
  topNav: PropTypes.node,
  sideNav: PropTypes.node,
  children: PropTypes.node,
  sideNavOpen: PropTypes.bool,
  topNavPanels: PropTypes.array,
  onNavButtonClick: PropTypes.func,
  onBackgroundClick: PropTypes.func,
  darkenBg: PropTypes.bool
}

const fadeIn = keyframes({
  from: {
    opacity: 0
  }
})

const style = {
  topPanel: {
    position: "absolute",
    top: "100%",
    left: 0,
    right: 0
  },
  fadedBg: {
    background: "black",
    position: "absolute",
    left: 0,
    right: 0,
    zIndex: 0,
    height: "100vh",
    opacity: "0.5",
    pointerEvents: "all",
    animation: "x .5s",
    animationName: fadeIn
  },
  hideIfDesktop: {
    display: "block",
    width: "100%",
    [breakpointDesktop]: {
      display: "none"
    }
  },
  wrapper: {
    display: "flex",
    flexDirection: "column",
    alignItems: "flex-start",
    pointerEvents: "none",
    [breakpointDesktop]: {
      flexDirection: "row",
      position: "absolute",
      left: 0,
      right: 0
    }
  },
  navButton: {
    ...BASE_HEADING,
    background: "#383838",
    color: COLOR_PALETTE.GRAY_DARK,
    display: "flex",
    padding: "1em 2em",
    alignItems: "center",
    whiteSpace: "nowrap",
    cursor: "pointer",
    flex: "1 1 100%",
    transition: "color 0.666s",
    [breakpointTablet]: {
      flex: "0 0 auto",
      ":hover": {
        color: COLOR_PALETTE.WHITE
      }
    },
    [breakpointDesktop]: {
      display: "none"
    }
  },
  topNavBar: {
    height: "4.5rem",
    [breakpointTablet]: {
      width: "100%"
    }
  },
  topNav: {
    pointerEvents: "auto",
    fontSize: "13px",
    width: "100%",
    display: "flex",
    position: "relative",
    order: -1,
    [breakpointDesktop]: {
      order: 1
    }
  },
  sidebar: {
    background: COLOR_PALETTE.GRAY1,
    maxHeight: "calc(100vh - 9rem)",
    overflowX: "auto",
    width: "100%",
    flex: "0 0 auto",
    [breakpointTablet]: {
      width: sidebarWidth
    },
    [breakpointDesktop]: {
      height: "100vh"
    }
  },
  main: {
    background: COLOR_PALETTE.GRAY_LIGHTER,
    minHeight: "100vh",
    [breakpointDesktop]: {
      paddingTop: "4.5rem",
      marginLeft: `${sidebarWidth}px`
    }
  }
}

export default withRadium(
  DetectCompact({
    threshold: [tabletWidth, desktopWidth]
  })
)(NavigationLayout)



// WEBPACK FOOTER //
// ./src/containers/mymazda/navigation/navigation-layout.jsx